/* eslint-disable react/prop-types */
import axios from 'axios';
import Cookies from 'js-cookie';
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import React, { useCallback, useEffect, useState } from 'react';
// api
import ApiKey from '../../api/ApiKey';
import BaseApi from '../../api/BaseApi';
// components
import Sidebar from '../Sidebar';
import Footer from '../../element/Footer';
import NavBar from '../../element/NavBar';
import ShowVacancies from './ShowVacancies';
import SmallLoading from '../../element/SmallLoading';
// helpers
import { logOutIfTokenExpired, resultInfo } from '../../helpers';

const ManageJob = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('global');
  const userType = Cookies.get('user_type');
  const tokenKey = Cookies.get('tokenClient');

  const [inputValue, setInputValue] = useState('');
  const [pagination, setPagination] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [smallLoading, setSmallLoading] = useState(true);
  const [manageJobData, setManageJobData] = useState(null);

  const handleSearchChange = useCallback(e => {
    const { value } = e.target;

    setInputValue(value);
    debouncedHandleSearchChange(value);
    }, []); // eslint-disable-line

  const handlePageChange = async page => {
    window.scrollTo(0, 0);

    try {
      setSmallLoading(true);
      setPagination(prev => ({
        ...prev,
        current_page: page,
      }));

      const response = await axios.get(
        BaseApi + '/job/management',
        {
          params: {
            page,
            search: searchQuery ? searchQuery : null,
            perPage: pagination ? pagination.per_page : 10,
          },
          headers: {
            key: ApiKey,
            token: tokenKey,
            contentType: 'application/json',
          },
        },
      );

      if (response.data.status === 200) {
        setPagination(response.data.meta);
        setManageJobData(response.data.data);
      } else {
        resultInfo('error', response.data.message, t('employerCreateJob.close'));
      }

      setSmallLoading(false);
    } catch (error) {
      setSmallLoading(false);

      console.error('Error fetching Jobs List', error);
    }
  };

  const getData = async () => {
    try {
      setSmallLoading(true);

      const response = await axios.get(
        BaseApi + '/job/management',
        {
          params: {
            page: 1,
            perPage: 10,
            search: searchQuery ? searchQuery : null,
          },
          headers: {
            key: ApiKey,
            token: tokenKey,
            contentType: 'application/json',
          },
        },
      );

      if (response.data.status === 200) {
        setPagination(response.data.meta);
        setManageJobData(response.data.data);
      } else {
        resultInfo('error', response.data.message, t('employerManageJobs.close'));
      }

      setSmallLoading(false);
    } catch (error) {
      setSmallLoading(false);

      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      }

      console.error('Cannot get manage job data', error);
    }
  };

  const debouncedHandleSearchChange = debounce(value => {
    setSearchQuery(value);
  }, 500);

  useEffect(() => {
    if (userType === 'candidate' || !tokenKey) {
      navigate('/user/employerlogin');
    } else {
      getData();

      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate, userType, searchQuery]); // eslint-disable-line

  return (
    <>
      <NavBar />
      <div className='container manageJob'>
        <div className='row'>
          <div className='col-lg-3'>
            <Sidebar />
          </div>
          <div className='col-lg-9 mb-5'>
            <div className='MJHeader PageHeader'>
              <div className='TopHaddingTitle'>
                <div className='TopHaddingTitleSec1'>
                  <h3 className=''>
                    <i>
                      <img src='/Images/employerSide/icon2color.png' alt='' />
                    </i>
                    <span>{t('employerManageJobs.manageJobs')}</span>
                  </h3>
                  <Link to='/user/createjob'>
                    <button type='button' className='btn btn-primary button1'>
                      {t('employerManageJobs.createJob')}
                    </button>
                  </Link>
                </div>
                <div className='manageSubadminPart1 APBasic'>
                  <form onSubmit={e => e.preventDefault()}>
                    <div className='manageSubadminPart1Sec1'>
                      <p style={{ fontSize: '18px' }}>
                        {t('employerManageJobs.searchTitle')}
                      </p>
                      <div className='APDashboardSearchBx mt-4'>
                        <input
                          type='text'
                          id='searchQuery'
                          name='searchQuery'
                          value={inputValue}
                          className='form-control'
                          style={{ maxWidth: '100%' }}
                          onChange={handleSearchChange}
                          placeholder={t('employerManageJobs.search')}
                        />
                      </div>
                    </div>
                  </form>
                </div>
                {
                  smallLoading
                    ? (
                      <div className='text-center mt-5'>
                        <SmallLoading />
                      </div>
                    ) : (
                      <div className='MJBody mt-5'>
                        {
                          manageJobData
                            ? (
                              manageJobData?.map(i => (
                                <div key={i.id}>
                                  <h2 id={i.id}>{i.full_name}</h2>
                                  <p className='text-muted'>
                                    {i.role === 'owner' ? t('employerManageJobs.owner') : t('employerManageJobs.manager')}
                                  </p>
                                  <ShowVacancies
                                    t={t}
                                    managerId={i.id}
                                    tokenKey={tokenKey}
                                    searchQuery={searchQuery}
                                    vacanciesCount={i.jobs_count}
                                  />
                                </div>
                              ))
                            ) : ''
                        }
                      </div>
                    )
                }
                <div className='manageJobPagination'>
                  <p className='text-muted empPaginationData'>
                    {t('employerManageJobs.managersCount')}
                    {' '}
                    {pagination?.from ? pagination?.from : 0} - {pagination?.to ? pagination?.to: 0}
                    {' '}
                    {t('pagination.of')} {pagination?.total ? pagination?.total : 0}
                  </p>
                  <div className='d-flex justify-content-center empPaginationButton'>
                    <button
                      disabled={smallLoading || pagination?.current_page === 1}
                      className='btn navButton1 me-2'
                      onClick={() => handlePageChange(pagination?.current_page - 1)}
                    >
                      {t('pagination.Prev')}
                    </button>
                    <button
                      className='btn navButton1'
                      disabled={smallLoading || pagination?.to >= pagination?.total}
                      onClick={() => handlePageChange(pagination?.current_page + 1)}
                    >
                      {t('pagination.Next')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ManageJob;
